/**
 * Build a reliable dealer search URL for a product. Always uses search queries
 * rather than AI-generated direct links, since retailers frequently change
 * their URL structures causing direct links to 404 or redirect to wrong products.
 *
 * Returns undefined for unknown dealers.
 */
export function getDealerUrl(
  dealer: string,
  _aiUrl: string | undefined,
  brand: string,
  model: string,
): string | undefined {
  const q = encodeURIComponent(`${brand} ${model}`).replace(/%20/g, '+');
  const dl = dealer.toLowerCase();

  if (dl.includes('b&h') || dl.includes('bh photo') || dl.includes('bhphoto'))
    return `https://www.bhphotovideo.com/c/search?Ntt=${q}&N=0&stype=search`;
  if (dl.includes('adorama'))
    return `https://www.adorama.com/l/?searchinfo=${q}`;
  if (dl.includes('amazon'))
    return `https://www.amazon.com/s?k=${q}`;
  if (dl.includes('bedford'))
    return `https://www.bedfordcamera.com/search?q=${q}`;
  if (dl.includes('sony') && dl.includes('store'))
    return `https://electronics.sony.com/search/${q}`;
  if (dl.includes('canon') && dl.includes('store'))
    return `https://www.usa.canon.com/shop?q=${q}`;
  if (dl.includes('nikon') && dl.includes('store'))
    return `https://www.nikonusa.com/search?q=${q}`;
  if (dl.includes('fujifilm') && dl.includes('store'))
    return `https://fujifilm-x.com/en-us/products/?q=${q}`;
  return undefined;
}
